// Public routes that don't require authentication
// Used by API interceptor and AuthContext to avoid 401 redirects on these pages
export const PUBLIC_PATHS = ["/auth", "/reset-password", "/forgot-password"];

export function isPublicPath(pathname) {
  return PUBLIC_PATHS.some((p) => pathname.startsWith(p));
}
